/*
 * @Author: cryi.liu
 * @Date: 2020-05-09 15:14:51
 * @LastEditTime: 2020-09-21 14:07:26
 * @Description: axios 创建实例配置
 */
import axios from 'axios';
import qs from 'qs';
import store from '../store';

const queryStringFormat = (data) => qs.stringify(data, { indices: false });

axios.defaults.transformRequest = [queryStringFormat];
axios.defaults.timeout = 10000;

const axiosInstance = axios.create();

// 请求拦截器
axiosInstance.interceptors.request.use(
  (config) => {
    if (process.env.NODE_ENV === 'development') {
      config.headers.psstoken = 'eyJhbGciOiJIUzUxMiJ9.eyJ1c2VyRGV2aWNlIjp7InVzZXJDb2RlIjoiYWRtaW4iLCJsb2dpbklkIjoiNTJkNWY0NmQtMjMwYS00YmQ3LTlmODAtZGZlM2U4NDdiOGVlIiwiZGV2aWNlQ29kZSI6IkREQTQ5NzBELTkwMjItNEQ3NC05RDI3LUY3MEM0QjAxMzkzRSIsImRldmljZVR5cGUiOiJpT1MifSwiZXhwIjoxNjY1NDUxNzgxfQ.8IpKXkth8QLm0GYaCCKp1soEUE0Jhm1vOF2uXUlspj288P3lvP-TIT5uEPOd_3aaxi7KGSOUZLxWGqpZz3CC4Q';
      // config.headers.psstoken = store.getters['authStore/token'];

      config.headers.examToken = 'eyJhbGciOiJIUzUxMiJ9.eyJleGFtVG9rZW4iOnsidXNlckNvZGUiOiI0OTkxMDAxOTQiLCJleGFtSWQiOiItMjgzOTc1Mjk5MTU0NDU1MzM4MCJ9LCJleHAiOjE2MDc2ODQ4MTF9.NJ616BQ7aES0G-AlzG2OFOBqSScy_mELcHRp010DHuLOhDy-IXJGWH4Qt3JzHU5NipIDL-dxoreaAJvdjObmag';
    } else {
      config.headers.psstoken = store.getters['authStore/token'];

      config.headers.examToken = store.getters['authStore/examToken'];
    }
    return config;
  },
  (error) => Promise.reject(error)
  ,
);

// 响应拦截器
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error),
);

export default axiosInstance;
